import { OrderLabel } from '@seen/core/models/orderLabel'
import type { ReactNode } from 'react'
import { LabelColor } from '#src/components/LabelColor.tsx'
import { RowBadge, type RowBadgeProps } from '#src/components/TaskRowBadge.tsx'
import { useRead } from '#src/hooks/useRead.ts'

export interface OrderLabelBadgeProps extends Omit<
  RowBadgeProps,
  'icon' | 'children'
> {
  label: string | undefined
}

export function OrderLabelBadge({
  label: labelReference,
  ...delegated
}: OrderLabelBadgeProps): ReactNode {
  const { data: label } = useRead(OrderLabel, labelReference)

  if (label?.isDeleted) {
    return null
  }

  return (
    <RowBadge icon={<LabelColor color={label?.color} />} {...delegated}>
      {label?.name}
    </RowBadge>
  )
}
